import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SuiModule } from 'ng2-semantic-ui';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';

// Components
import { HeaderComponent } from './components/header/header.component';
import { UserLoginComponent } from './user-login/user-login.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { NotificationMessageComponent } from './notification-message/notification-message.component';

// Import the pipes
import { MapToIterable } from './pipes/map-to-iterable.pipe';
import { SafePipe } from './pipes/safe-pipe.pipe';
import { ConnectionsSearchBy } from './pipes/connections-search-by.pipe';
import { InstrumentsSearchBy } from './pipes/instruments-search-by.pipe';
import { GenresSearchBy } from './pipes/genres-search-by.pipe';
import { MessagesListSearchBy } from './pipes/messages-list-search-by.pipe';

@NgModule({
  imports: [
    CommonModule,
    SuiModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
  ],
  declarations: [
    HeaderComponent,
    LoadingSpinnerComponent,
    NotificationMessageComponent,
    MapToIterable,
    SafePipe,
    ConnectionsSearchBy,
    InstrumentsSearchBy,
    MessagesListSearchBy,
    GenresSearchBy
  ],
  exports: [
    HeaderComponent,
    MapToIterable,
    SafePipe,
    FormsModule,
    ConnectionsSearchBy,
    InstrumentsSearchBy,
    MessagesListSearchBy,
    GenresSearchBy,
    CommonModule,
    ReactiveFormsModule,
    SuiModule,
    LoadingSpinnerComponent,
    NotificationMessageComponent
  ]
})
export class SharedModule {}
